import { Routes } from '@angular/router';

/**
 * Route area User Management. Di-spread di `main-layout.routes.ts` TANPA segmen prefix karena menu
 * BE mengarah langsung ke `admin/personnels` — beda dari Master Data yang bersarang di `master`.
 *
 * `path` tiap entry HARUS cocok dengan `navigable.path` dari navigation_tree/MAIN (menu digerakkan
 * BE; sidebar memakai path itu apa adanya sebagai `routerLink`). `title` memakai key i18n
 * (I18nTitleStrategy).
 */
export const userManagementRoutes: Routes = [
  {
    path: 'personnels',
    loadComponent: () =>
      import('./personnels/pages/personnels-list/personnels').then((c) => c.PersonnelsComponent),
    title: 'personnel.title',
  },
  {
    path: 'buyers',
    loadComponent: () => import('./buyers/pages/buyers-list/buyers').then((c) => c.BuyersComponent),
    title: 'buyer.title',
  },
  {
    path: 'roles',
    loadComponent: () => import('./roles/pages/roles-list/roles').then((c) => c.RolesComponent),
    title: 'role.title',
  },
  {
    // Menu "Vendors" di area User Management — halaman untuk menyalakan/mematikan state vendor.
    // Path memakai UNDERSCORE karena harus sama persis dengan `navigable.path` dari
    // navigation_tree/MAIN; folder fiturnya sendiri bernama `vendor-states`.
    // BEDA halaman dengan `/admin/vendors` (vendor-management) walau endpoint list-nya sama.
    path: 'vendor_tools',
    loadComponent: () =>
      import('./vendor-states/pages/vendor-states-list/vendor-states').then(
        (c) => c.VendorStatesComponent,
      ),
    title: 'vendorState.title',
  },
  {
    // Menu "Users" — daftar akun aplikasi, READ-ONLY (list + filter + sort saja).
    path: 'users',
    loadComponent: () => import('./users/pages/users-list/users').then((c) => c.UsersComponent),
    title: 'user.title',
  },
  {
    // Menu "Access Logs" (Log Monitoring) — log akses READ-ONLY, hanya Superadmin (kontrak §17.2).
    // Path memakai UNDERSCORE karena harus sama dengan `navigable.path` navigation_tree/MAIN.
    path: 'access_logs',
    loadComponent: () =>
      import('./access-logs/pages/access-logs-list/access-logs').then((c) => c.AccessLogsComponent),
    title: 'accessLog.title',
  },
  {
    // Menu "Navigations" — daftar grup navigasi (MAIN, PUBLIC). Tanpa kolom Aksi & tanpa New Data:
    // jalan ke detail lewat link pada kolom Name.
    path: 'navigations',
    loadComponent: () =>
      import('./navigations/pages/navigations-list/navigations').then(
        (c) => c.NavigationsComponent,
      ),
    title: 'navigation.title',
  },
  {
    // Detail navigation — TIDAK ada di menu BE (dicapai dari link kolom Name). Sidebar tetap
    // menyorot menu Navigations karena `isActive()` mencocokkan prefix `/admin/navigations/`.
    path: 'navigations/:id',
    loadComponent: () =>
      import('./navigations/pages/navigation-detail/navigation-detail').then(
        (c) => c.NavigationDetailComponent,
      ),
    title: 'navigation.detail.title',
  },
  {
    // Detail role — TIDAK ada di menu BE (dicapai dari link kolom Name), jadi tak terikat
    // `navigable.path`. Tab aktif disimpan di query param `?tab=`, bukan child route.
    // Sidebar tetap menyorot menu Roles karena `isActive()` mencocokkan prefix `/admin/roles/`.
    path: 'roles/:id',
    loadComponent: () =>
      import('./roles/pages/role-detail/role-detail').then((c) => c.RoleDetailComponent),
    title: 'role.detail.title',
  },
];
